import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { proformaExportRoute } from '@atlassian/jira-router-routes-proforma-routes/src/proformaExportRoute.tsx';
import ProformaExport, { LazyProformaExport } from './ui/export/index.tsx';

export const proformaExportRouteEntry = createEntry(proformaExportRoute, () => ({
	group: 'proforma',
	layout: globalLayout,
	resources: [...getNavigationResources()],
	component: ProformaExport,
	forPaint: [LazyAtlassianNavigation, LazyProformaExport],
}));
